var map = {
	"./coin1.png": "8b88",
	"./coin2.png": "4f70",
	"./coin3.png": "30d5",
	"./coin4.png": "b424",
	"./coin5.png": "956f",
	"./coin6.png": "e3e2",
	"./coin_background.png": "3e01"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8ee";